import { httpCreate } from './http';
const http = httpCreate('/srv/service-mch-complaints');
export const serviceMchComplaints = {
	list(params) {
		return http.get(`/list`, { params });
	},
	response(id, data) {
		return http.post(`/response/${id}`, data);
	},
	history(id) {
		return http.get(`/history/${id}`);
	},
	complete(id) {
		return http.post(`/complete/${id}`);
	},
};
